import React from "react";
import Work from "./Work";

const PortfolioComp = () => {
  return (
    <>
      <div id="projects" className="portfolio">
        <h1 className="mainHeading">My Projects</h1>
        <p className="mainPara">My Recent Work</p>
        <Work/>
      </div>
    </>
  );
};

export default PortfolioComp;
